/**
 * @generated SignedSource<<89e2c5602f8c0bc378dca90c035a71a6>>
 * @relayHash 19f10f8de6c2b80fec0ffc551804bcb4
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 55cb43f699f1937080aec020c994d4de68c704751fd256a7a01350c89ed95f4c

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountSecurityPageQuery$variables = {
  account: string;
};
export type accountSecurityPageQuery$data = {
  readonly accountBySlug: {
    readonly __typename: "Organization";
    readonly " $fragmentSpreads": FragmentRefs<"organizationOidcGroupNameFragment" | "organizationOidcIssuerFragment">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type accountSecurityPageQuery = {
  response: accountSecurityPageQuery$data;
  variables: accountSecurityPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "account"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "account"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "accountSecurityPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": null,
          "kind": "LinkedField",
          "name": "accountBySlug",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "organizationOidcIssuerFragment"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "organizationOidcGroupNameFragment"
                }
              ],
              "type": "Organization",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "accountSecurityPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "accountBySlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "oidcIssuer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "oidcGroupName",
                "storageKey": null
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "19f10f8de6c2b80fec0ffc551804bcb4",
    "id": "55cb43f699f1937080aec020c994d4de68c704751fd256a7a01350c89ed95f4c",
    "metadata": {},
    "name": "accountSecurityPageQuery",
    "operationKind": "query",
    "text": "query accountSecurityPageQuery(\n  $account: String!\n) {\n  accountBySlug(slug: $account) {\n    __typename\n    ... on Organization {\n      ...organizationOidcIssuerFragment\n      ...organizationOidcGroupNameFragment\n    }\n    id\n  }\n}\n\nfragment organizationOidcGroupNameFragment on Organization {\n  id\n  oidcGroupName\n}\n\nfragment organizationOidcIssuerFragment on Organization {\n  id\n  oidcIssuer\n}\n"
  }
};
})();

(node as any).hash = "30c2e193d028ba64691772545bafba45";

export default node;
